module.exports = __webpack_public_path__ + "img/server-and-application.6ba1a2d0.jpg";